<template>
  <div class="tabs-box">
    <div class="tabs-nav">
      <div :class="['tabs-nav-tab', { 'tabs-nav-tab-active': currentTab === components.modules }]"
        @click="currentTab = components.modules, isTab = true">页面</div>
      <div :class="['tabs-nav-tab', { 'tabs-nav-tab-active': currentTab === components.basics }]"
        @click="currentTab = components.basics, isTab = false">基本组件</div>
    </div>
    <el-alert v-if="isItem && currentTab === components.basics" center :closable="false" title="拖拽组件到页面" type="warning">
      </el-alert>
    <div :class="currentTab === components.basics && 'tabs-content'" :style="{ display: !isItem ? 'flex' : 'grid' }"
      v-if="currentTab === components.basics">
      <div v-if="!isItem" style="width: 100%;">
        <el-empty :image="kimg" description="当前页面不支持组件"></el-empty>
      </div>
      <draggable v-model="arr1" :options="{ group: { name: 'itxst', pull: 'clone' }, sort: false }" :group="grpupA"
        animation="300" dragClass="dragClass" ghostClass="ghostClass" chosenClass="chosenClass" @start="onStart"
        @end="onEnd" :move="onMove" @unchoose="onUnchoose" v-for="(component, index) in currentTab" :key="index">

        <component-card v-if="isItem" :component="component" :currentTab="isTab">

        </component-card>
      </draggable>
    </div>
    <div v-if="currentTab === components.modules">
      <pageView :component="currentTab" @click="handleClick" />
    </div>
  </div>
</template>

<script>
import ComponentCard from '../components/ComponentCard'
import pageView from '../components/pageView'
import defImg from '../assets/no-support.svg'
import draggable from 'vuedraggable'

export default {
  name: 'ComponentTabs',
  components: { ComponentCard, pageView, defImg, draggable },
  props: {
    components: Object,
    drag: Boolean
  },
  data: function () {
    console.log(this.components)
    return {
      currentTab: this.components.modules,
      isTab: true,
      isItem: true,
      kimg: defImg,
      grpupA: {
        name: 'site',
        pull: 'clone',
        put: false
      },
      arr1: this.components.basics,
      style: 'min-height: 100%; display: block;',
      isMove: false
    }
  },
  methods: {
    handleClick (item) {
      this.isItem = item.name
      if (
        item.name === '首页' ||
        item.name === '联系' ||
        item.name === '关于'
      ) {
        this.isItem = true
      } else {
        this.isItem = false
      }
      this.$emit('click', item)
    },
    onStart (e) {
      // this.drag = true;
      this.isMove = false
      this.$emit('update:drag', true)
    },
    onEnd (e) {
      // this.drag = false;
      const item = this.arr1.find(i => i.name === e.target.innerText)
      if (this.isMove) {
        this.$emit('click', item, e.newIndex)
      }
      this.$emit('update:drag', false)
    },
    onMove (e, originalEvent) {
      this.isMove = true
      return true
    },
    onUnchoose (e) {
      if (e.to.tagName.toLowerCase() === 'div') {
        this.isMove = false
      } else {
        this.isMove = true
      }
    }
  }
}
</script>

<style scoped>
.tabs-box {
  width: 300px;
  border-radius: 0;
  border: 0;
  box-shadow: 3px 0 20px 0 hsla(0, 0%, 82%, 0.5);
  overflow: auto !important;
}

.tabs-box .tabs-content {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 10px;
}

.tabs-box .tabs-nav {
  display: flex;
  justify-content: center;
  height: 40px;
  cursor: pointer;
  border-bottom: 1px solid #e1e1e1;
  background-color: #f5f7fa;
  font-size: 16px;
  font-weight: bold;
}

.tabs-box .tabs-nav .tabs-nav-tab {
  float: left;
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  position: relative;
}

.tabs-box .tabs-nav .tabs-nav-tab:hover {
  color: #2d8cf0;
}

.tabs-box .tabs-nav .tabs-nav-tab-active {
  color: #2d8cf0;
}

.tabs-box .tabs-nav .tabs-nav-tab-active:after {
  content: "";
  width: 80px;
  height: 2px;
  background-color: #58b7ff;
  position: absolute;
  bottom: 0;
  left: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ComponentTabs.vue